// non-react related initialization
import 'pubsub';
import 'service/link-handler';
import history from './history';

const { win, application } = window;

window.dataLayer = window.dataLayer || [];

// tip: use document.querySelector('webview').openDevTools(); for internal webview
document.addEventListener('keydown', (zEvent: KeyboardEvent) => {
    if (application.debug && zEvent.ctrlKey && zEvent.shiftKey && zEvent.key === 'I') {
        win.webContents.openDevTools();
    }
});
if (!application.debug) {
    console.log = () => { };
}

window.paramsHandler = (params: any) => {
    if ('initRoute' in params) {
        history.push(`/${window.win.name}${params.initRoute}`);
    } else if ('stateName' in params) {
        win.stateName = params.stateName;
    }
};

// language change function
window.launcherLanguageChange = (lang: string) => {
    try {
        for (let prop in application.params.locales) {
            if (prop.indexOf(lang) >= 0) {
                window.nxlApi.localization.setLocale({ locale: prop });
                break;
            }
        }
    } catch (e) {
        window.nxlApi.frontEnd.centralizeError({ error: { code: 21010 } });
    }
};

// save a store info into local storage (value - 'google')
const { store } = window.application.params.user_data;
if (store) {
    localStorage.setItem('store', store);
}

window._FE_version = process.env.REACT_APP_VERSION;

// eslint-disable-next-line no-console
console.log(`############ ${process.env.REACT_APP_NAME} : ${process.env.REACT_APP_VERSION} ############`);
